<div class="container">
  <h2>{{ title }}</h2>
  <p>{{ subtitle }}</p>
  <div class="actions">
    <button (click)="cancel()" mat-flat-button>Cancel</button>
    <button color="primary" (click)="confirm()" mat-flat-button>Confirm</button>
  </div>
</div>
